// 修正: mbs-ecに合わせて会員ポイント表示機能を追加
import { initAccountPoint } from "./namespace/account";
// 修正: mbs-ecに合わせて住所フォーム機能を追加
import { initAddressForm } from "./namespace/address";
// 修正: 同梱不可商品の混在カートイン防止を追加
import { initExclusiveCart } from "./namespace/cart";
// レシピ詳細
import { articleRecipe } from "./namespace/articleRecipe";
// コレクション
import { collectionText } from "./namespace/collection";
// 商品詳細
import { product } from "./namespace/product";
// 修正: レシピ子カテゴリ（Section Rendering API ページネーション）
import { recipeChild } from "./namespace/recipeChild";
// レシピトップ
import { recipeTop } from "./namespace/recipeTop";
// レシピ著者詳細
import { recipeAuthor } from "./namespace/recipeAuthor";
// TOP
import { top } from "./namespace/top";
// 閲覧履歴
import { initViewedHistory } from "./namespace/viewedHistory";
// 共通
import { initDragScroll } from "./util/dragScroll";
// 修正: 特集コンテンツのループ動画再開時の映像乱れを防ぐ
import { featureContent } from "./namespace/featureContent";
// 修正: 特集の縦割り画像アニメーションを追加
import { featureSplitImages } from "./namespace/featureSplitImages";
// 修正: 特集の囲みテキストアニメーションを追加
import { featureRectText } from "./namespace/featureRectText";
// 修正: 特集タイトル下のラインアニメーションを追加
import { featureTitleLine } from "./namespace/featureTitleLine";

const hasTemplateClass = (className: string) =>
  Boolean(document.body?.classList.contains(className));

const hasTemplate = (name: string) => hasTemplateClass(`template-${name}`);

const hasTemplateSuffix = (name: string, suffix: string) =>
  hasTemplateClass(`template-${name}--${suffix}`);

const shouldInitAccountPoint = () =>
  hasTemplate("customers-account") ||
  hasTemplate("account") ||
  hasTemplateSuffix("customers", "account");

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    top();
    product();
    articleRecipe();
    recipeChild();
    recipeTop();
    recipeAuthor();
    collectionText();
    featureContent();
    featureSplitImages();
    featureRectText();
    featureTitleLine();
    initDragScroll();
    // 閲覧履歴機能（新仕様）
    initViewedHistory();
    // 住所フォーム初期化（郵便番号自動補完、バリデーション）
    if (document.body.classList.contains("template-customers-addresses")) {
      initAddressForm();
    }
    // 同梱不可商品の混在チェックを初期化
    initExclusiveCart();
    // 会員ポイント/ランク表示
    if (shouldInitAccountPoint()) {
      initAccountPoint();
    }
  });
} else {
  // DOM already loaded
  top();
  product();
  articleRecipe();
  recipeChild();
  recipeTop();
  recipeAuthor();
  collectionText();
  featureContent();
  featureSplitImages();
  featureRectText();
  featureTitleLine();
  initDragScroll();
  // 閲覧履歴機能（新仕様）
  initViewedHistory();
  // 住所フォーム初期化（郵便番号自動補完、バリデーション）
  if (document.body.classList.contains("template-customers-addresses")) {
    initAddressForm();
  }
  // 同梱不可商品の混在チェックを初期化
  initExclusiveCart();
  // 会員ポイント/ランク表示
  if (shouldInitAccountPoint()) {
    initAccountPoint();
  }
}
